// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queue-widget .visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.queue-widget {
  background: var(--color-surface-light, #fff);
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-lg, 12px);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.queue-widget__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md, 16px);
  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);
  border-bottom: 1px solid var(--color-border, #e8e3d8);
}

/* When the widget is collapsed the header loses its bottom border
   so the card reads as a single quiet row rather than a header with
   nothing beneath it. */
.queue-widget--collapsed .queue-widget__header {
  border-bottom: none;
}

/* Title-as-button wraps the h3 + caret so the whole heading row
   (excluding the filter/sort controls) is one keyboard-focusable
   click target. Reset the button chrome to keep the visual identical
   to the previous plain <h3>. */
.queue-widget__toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-align: left;
  border-radius: var(--border-radius-sm, 4px);
}
.queue-widget__toggle:hover .queue-widget__title {
  color: var(--color-secondary, #4c6a58);
}
.queue-widget__toggle:focus-visible {
  outline: 2px solid var(--color-info, #5c7cba);
  outline-offset: 3px;
}

.queue-widget__caret {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  color: var(--color-text-secondary, #8a919b);
  font-size: 0.85rem;
  line-height: 1;
  transition: transform 0.15s ease;
}
.queue-widget__caret--collapsed {
  transform: rotate(-90deg);
}

.queue-widget__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--color-primary, #1f2a44);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  transition: color 0.15s ease;
}

.queue-widget__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--color-primary, #1f2a44);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
}

.queue-widget__controls {
  display: flex;
  gap: var(--spacing-sm, 8px);
  align-items: center;
  flex-wrap: wrap;
}

.queue-widget__select {
  padding: 4px 8px;
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-sm, 4px);
  background: #fff;
  color: var(--color-text-primary, #5c636b);
  font-size: 0.85rem;
  cursor: pointer;
}

/* ── Bulk-action toolbar ───────────────────────────────────────────── */

.queue-widget__bulkbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md, 16px);
  padding: 10px var(--spacing-lg, 24px);
  border-bottom: 1px solid var(--color-border, #e8e3d8);
  background: var(--color-surface, #f3efe6);
}

.queue-widget__selectall {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  font-size: 0.85rem;
  color: var(--color-text-primary, #5c636b);
  cursor: pointer;
  user-select: none;
}

.queue-widget__selectall input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--color-secondary, #4c6a58);
}

.queue-widget__bulk-accept {
  padding: 6px 14px;
  border-radius: var(--border-radius-sm, 4px);
  border: 1px solid transparent;
  background: var(--color-secondary, #4c6a58);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity var(--transition-fast, 150ms ease-in-out);
}
.queue-widget__bulk-accept:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.queue-widget__body {
  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);
}

.queue-widget__empty {
  padding: var(--spacing-xl, 32px) var(--spacing-lg, 24px);
  text-align: center;
  color: var(--color-text-secondary, #8a919b);
  font-size: 0.95rem;
}

.queue-widget__loading,
.queue-widget__error {
  padding: var(--spacing-lg, 24px);
  color: var(--color-text-secondary, #8a919b);
  text-align: center;
}
.queue-widget__error {
  color: var(--color-error, #d44c4c);
}

.queue-widget__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 8px);
}

/* ── Item card ─────────────────────────────────────────────────────── */

.queue-item {
  display: grid;
  /* Select, badge, body, view button, actions. View sits between the
     doc info and the accept/reject actions on the right so reviewers'
     eyes land on the primary action last. */
  grid-template-columns: auto auto 1fr auto auto;
  gap: var(--spacing-md, 16px);
  align-items: start;
  padding: var(--spacing-md, 16px);
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-md, 8px);
  background: #fff;
  transition: border-color var(--transition-fast, 150ms ease-in-out),
    background-color var(--transition-fast, 150ms ease-in-out);
}

/* .queue-item__view-btn styles removed — the queue row now uses the
   shared <ViewButton /> from apps/shell/src/components/ViewButton.tsx
   for a single visual across every surface that opens the preview
   modal. Grid placement of the button on this row is set on the
   parent's .queue-item grid — see the desktop and mobile blocks
   below. */
.queue-item--selected {
  border-color: var(--color-secondary, #4c6a58);
  background: rgba(76, 106, 88, 0.04);
}

.queue-item__select {
  display: inline-flex;
  align-items: center;
  padding-top: 2px;
  cursor: pointer;
}
.queue-item__select input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--color-secondary, #4c6a58);
}

.queue-item__badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(184, 115, 51, 0.12);
  color: var(--color-accent, #b87333);
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}
.queue-item__badge--tags {
  background: rgba(76, 106, 88, 0.12);
  color: var(--color-secondary, #4c6a58);
}
.queue-item__badge--split {
  background: rgba(31, 42, 68, 0.10);
  color: var(--color-primary, #1f2a44);
}
.queue-item__badge--event {
  background: rgba(92, 124, 186, 0.14);
  color: var(--color-info, #5c7cba);
}
.queue-item__badge--invitation {
  background: rgba(184, 115, 51, 0.14);
  color: var(--color-accent, #b87333);
}

.queue-item__event-when {
  font-size: 0.85rem;
  color: var(--color-text-primary, #5c636b);
  font-weight: 500;
}
.queue-item__event-location {
  font-size: 0.8rem;
  color: var(--color-text-secondary, #8a919b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-item__confidence {
  text-transform: capitalize;
  cursor: help;
}
.queue-item__reasoning {
  font-size: 0.8rem;
  color: var(--color-text-primary, #5c636b);
  font-style: italic;
  border-left: 2px solid var(--color-border, #e8e3d8);
  padding-left: 8px;
}

.queue-item__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.queue-item__doc-name {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--color-primary, #1f2a44);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-item__original {
  font-size: 0.8rem;
  color: var(--color-text-secondary, #8a919b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-item__input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-sm, 4px);
  font-size: 0.95rem;
  color: var(--color-primary, #1f2a44);
  background: var(--color-surface-light, #fff);
  font-family: inherit;
}
.queue-item__input:focus {
  outline: none;
  border-color: var(--color-secondary, #4c6a58);
  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);
}

.queue-item__meta {
  font-size: 0.75rem;
  color: var(--color-text-secondary, #8a919b);
}

.queue-item__actions {
  display: flex;
  gap: var(--spacing-sm, 8px);
  align-items: flex-start;
}

.queue-item__btn {
  /* inline-flex + gap lays out an optional leading icon (accept
     buttons carry a <CheckIcon />) next to the label. Text-only
     variants are unaffected — just one child in the flex row. */
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: var(--border-radius-sm, 4px);
  border: 1px solid transparent;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition:
    background var(--transition-fast, 150ms ease-in-out),
    border-color var(--transition-fast, 150ms ease-in-out),
    opacity var(--transition-fast, 150ms ease-in-out);
}
.queue-item__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/* Accept — soft-secondary tint fill (matches Upload Inbox Save) plus
   a subtle secondary border + heavier weight so the primary action
   reads as primary without going back to a saturated solid pill. */
.queue-item__btn--accept {
  background: rgba(76, 106, 88, 0.15);
  color: var(--color-secondary, #4c6a58);
  border-color: rgba(76, 106, 88, 0.35);
  font-weight: 600;
}
.queue-item__btn--accept:hover:not(:disabled) {
  background: rgba(76, 106, 88, 0.28);
  border-color: rgba(76, 106, 88, 0.55);
}
.queue-item__btn--reject {
  background: #fff;
  color: var(--color-text-primary, #5c636b);
  border-color: var(--color-border, #e8e3d8);
}

/* ── Tag chips ─────────────────────────────────────────────────────── */

.queue-item__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  cursor: help;
}

/* Tag chip styles moved to apps/shell/src/components/tag-chip.css
   (.tag-chip family) — one visual across queue, upload inbox, and
   the document list. Kept mount here via QueueWidget.tsx's import. */

/* ── Narrow layout ─────────────────────────────────────────────────── */

@media (max-width: 640px) {
  .queue-item {
    /* Named areas mirror the desktop DOM order but stack vertically:
       select+badge on row 1, body on row 2, view+actions on row 3. */
    grid-template-columns: auto 1fr auto;
    grid-template-areas:
      "select badge   badge"
      "body   body    body"
      ".      view    actions";
  }
  .queue-item__select {
    grid-area: select;
  }
  .queue-item__badge {
    grid-area: badge;
    align-self: center;
  }
  .queue-item__body {
    grid-area: body;
  }
  /* Placement of the shared <ViewButton /> (renders .view-btn) inside
     the queue row's grid. The shared component handles its own
     tap-target sizing on mobile via ViewButton.css. */
  .queue-item .view-btn {
    grid-area: view;
    justify-self: flex-end;
  }
  .queue-item__actions {
    grid-area: actions;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/queue/components/QueueWidget.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,wDAAwD;EACxD,qDAAqD;AACvD;;AAEA;;wBAEwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;;;gCAGgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;EACrC,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,6BAA6B;EAC7B,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb;;4CAE0C;EAC1C,8CAA8C;EAC9C,4BAA4B;EAC5B,kBAAkB;EAClB,gCAAgC;EAChC,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;EAChB;8DAC4D;AAC9D;;AAEA;;;;;WAKW;AACX;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE;;gEAE8D;EAC9D,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;qDAGmD;AACrD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;;mEAEmE;AACnE;EACE,mCAAmC;EACnC,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;;qEAEqE;;AAErE,yEAAyE;;AAEzE;EACE;IACE;qEACiE;IACjE,oCAAoC;IACpC;;;8BAG0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;;sDAEoD;EACpD;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;AACF","sourcesContent":[".queue-widget .visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.queue-widget {\n  background: var(--color-surface-light, #fff);\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-lg, 12px);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.queue-widget__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-md, 16px);\n  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);\n  border-bottom: 1px solid var(--color-border, #e8e3d8);\n}\n\n/* When the widget is collapsed the header loses its bottom border\n   so the card reads as a single quiet row rather than a header with\n   nothing beneath it. */\n.queue-widget--collapsed .queue-widget__header {\n  border-bottom: none;\n}\n\n/* Title-as-button wraps the h3 + caret so the whole heading row\n   (excluding the filter/sort controls) is one keyboard-focusable\n   click target. Reset the button chrome to keep the visual identical\n   to the previous plain <h3>. */\n.queue-widget__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  border-radius: var(--border-radius-sm, 4px);\n}\n.queue-widget__toggle:hover .queue-widget__title {\n  color: var(--color-secondary, #4c6a58);\n}\n.queue-widget__toggle:focus-visible {\n  outline: 2px solid var(--color-info, #5c7cba);\n  outline-offset: 3px;\n}\n\n.queue-widget__caret {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  color: var(--color-text-secondary, #8a919b);\n  font-size: 0.85rem;\n  line-height: 1;\n  transition: transform 0.15s ease;\n}\n.queue-widget__caret--collapsed {\n  transform: rotate(-90deg);\n}\n\n.queue-widget__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--color-primary, #1f2a44);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  transition: color 0.15s ease;\n}\n\n.queue-widget__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--color-primary, #1f2a44);\n  color: #fff;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.queue-widget__controls {\n  display: flex;\n  gap: var(--spacing-sm, 8px);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.queue-widget__select {\n  padding: 4px 8px;\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-sm, 4px);\n  background: #fff;\n  color: var(--color-text-primary, #5c636b);\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n/* ── Bulk-action toolbar ───────────────────────────────────────────── */\n\n.queue-widget__bulkbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-md, 16px);\n  padding: 10px var(--spacing-lg, 24px);\n  border-bottom: 1px solid var(--color-border, #e8e3d8);\n  background: var(--color-surface, #f3efe6);\n}\n\n.queue-widget__selectall {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  font-size: 0.85rem;\n  color: var(--color-text-primary, #5c636b);\n  cursor: pointer;\n  user-select: none;\n}\n\n.queue-widget__selectall input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--color-secondary, #4c6a58);\n}\n\n.queue-widget__bulk-accept {\n  padding: 6px 14px;\n  border-radius: var(--border-radius-sm, 4px);\n  border: 1px solid transparent;\n  background: var(--color-secondary, #4c6a58);\n  color: #fff;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity var(--transition-fast, 150ms ease-in-out);\n}\n.queue-widget__bulk-accept:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.queue-widget__body {\n  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);\n}\n\n.queue-widget__empty {\n  padding: var(--spacing-xl, 32px) var(--spacing-lg, 24px);\n  text-align: center;\n  color: var(--color-text-secondary, #8a919b);\n  font-size: 0.95rem;\n}\n\n.queue-widget__loading,\n.queue-widget__error {\n  padding: var(--spacing-lg, 24px);\n  color: var(--color-text-secondary, #8a919b);\n  text-align: center;\n}\n.queue-widget__error {\n  color: var(--color-error, #d44c4c);\n}\n\n.queue-widget__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm, 8px);\n}\n\n/* ── Item card ─────────────────────────────────────────────────────── */\n\n.queue-item {\n  display: grid;\n  /* Select, badge, body, view button, actions. View sits between the\n     doc info and the accept/reject actions on the right so reviewers'\n     eyes land on the primary action last. */\n  grid-template-columns: auto auto 1fr auto auto;\n  gap: var(--spacing-md, 16px);\n  align-items: start;\n  padding: var(--spacing-md, 16px);\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-md, 8px);\n  background: #fff;\n  transition: border-color var(--transition-fast, 150ms ease-in-out),\n    background-color var(--transition-fast, 150ms ease-in-out);\n}\n\n/* .queue-item__view-btn styles removed — the queue row now uses the\n   shared <ViewButton /> from apps/shell/src/components/ViewButton.tsx\n   for a single visual across every surface that opens the preview\n   modal. Grid placement of the button on this row is set on the\n   parent's .queue-item grid — see the desktop and mobile blocks\n   below. */\n.queue-item--selected {\n  border-color: var(--color-secondary, #4c6a58);\n  background: rgba(76, 106, 88, 0.04);\n}\n\n.queue-item__select {\n  display: inline-flex;\n  align-items: center;\n  padding-top: 2px;\n  cursor: pointer;\n}\n.queue-item__select input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--color-secondary, #4c6a58);\n}\n\n.queue-item__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(184, 115, 51, 0.12);\n  color: var(--color-accent, #b87333);\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n.queue-item__badge--tags {\n  background: rgba(76, 106, 88, 0.12);\n  color: var(--color-secondary, #4c6a58);\n}\n.queue-item__badge--split {\n  background: rgba(31, 42, 68, 0.10);\n  color: var(--color-primary, #1f2a44);\n}\n.queue-item__badge--event {\n  background: rgba(92, 124, 186, 0.14);\n  color: var(--color-info, #5c7cba);\n}\n.queue-item__badge--invitation {\n  background: rgba(184, 115, 51, 0.14);\n  color: var(--color-accent, #b87333);\n}\n\n.queue-item__event-when {\n  font-size: 0.85rem;\n  color: var(--color-text-primary, #5c636b);\n  font-weight: 500;\n}\n.queue-item__event-location {\n  font-size: 0.8rem;\n  color: var(--color-text-secondary, #8a919b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.queue-item__confidence {\n  text-transform: capitalize;\n  cursor: help;\n}\n.queue-item__reasoning {\n  font-size: 0.8rem;\n  color: var(--color-text-primary, #5c636b);\n  font-style: italic;\n  border-left: 2px solid var(--color-border, #e8e3d8);\n  padding-left: 8px;\n}\n\n.queue-item__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.queue-item__doc-name {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--color-primary, #1f2a44);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.queue-item__original {\n  font-size: 0.8rem;\n  color: var(--color-text-secondary, #8a919b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.queue-item__input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-sm, 4px);\n  font-size: 0.95rem;\n  color: var(--color-primary, #1f2a44);\n  background: var(--color-surface-light, #fff);\n  font-family: inherit;\n}\n.queue-item__input:focus {\n  outline: none;\n  border-color: var(--color-secondary, #4c6a58);\n  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);\n}\n\n.queue-item__meta {\n  font-size: 0.75rem;\n  color: var(--color-text-secondary, #8a919b);\n}\n\n.queue-item__actions {\n  display: flex;\n  gap: var(--spacing-sm, 8px);\n  align-items: flex-start;\n}\n\n.queue-item__btn {\n  /* inline-flex + gap lays out an optional leading icon (accept\n     buttons carry a <CheckIcon />) next to the label. Text-only\n     variants are unaffected — just one child in the flex row. */\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: var(--border-radius-sm, 4px);\n  border: 1px solid transparent;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background var(--transition-fast, 150ms ease-in-out),\n    border-color var(--transition-fast, 150ms ease-in-out),\n    opacity var(--transition-fast, 150ms ease-in-out);\n}\n.queue-item__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n/* Accept — soft-secondary tint fill (matches Upload Inbox Save) plus\n   a subtle secondary border + heavier weight so the primary action\n   reads as primary without going back to a saturated solid pill. */\n.queue-item__btn--accept {\n  background: rgba(76, 106, 88, 0.15);\n  color: var(--color-secondary, #4c6a58);\n  border-color: rgba(76, 106, 88, 0.35);\n  font-weight: 600;\n}\n.queue-item__btn--accept:hover:not(:disabled) {\n  background: rgba(76, 106, 88, 0.28);\n  border-color: rgba(76, 106, 88, 0.55);\n}\n.queue-item__btn--reject {\n  background: #fff;\n  color: var(--color-text-primary, #5c636b);\n  border-color: var(--color-border, #e8e3d8);\n}\n\n/* ── Tag chips ─────────────────────────────────────────────────────── */\n\n.queue-item__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  cursor: help;\n}\n\n/* Tag chip styles moved to apps/shell/src/components/tag-chip.css\n   (.tag-chip family) — one visual across queue, upload inbox, and\n   the document list. Kept mount here via QueueWidget.tsx's import. */\n\n/* ── Narrow layout ─────────────────────────────────────────────────── */\n\n@media (max-width: 640px) {\n  .queue-item {\n    /* Named areas mirror the desktop DOM order but stack vertically:\n       select+badge on row 1, body on row 2, view+actions on row 3. */\n    grid-template-columns: auto 1fr auto;\n    grid-template-areas:\n      \"select badge   badge\"\n      \"body   body    body\"\n      \".      view    actions\";\n  }\n  .queue-item__select {\n    grid-area: select;\n  }\n  .queue-item__badge {\n    grid-area: badge;\n    align-self: center;\n  }\n  .queue-item__body {\n    grid-area: body;\n  }\n  /* Placement of the shared <ViewButton /> (renders .view-btn) inside\n     the queue row's grid. The shared component handles its own\n     tap-target sizing on mobile via ViewButton.css. */\n  .queue-item .view-btn {\n    grid-area: view;\n    justify-self: flex-end;\n  }\n  .queue-item__actions {\n    grid-area: actions;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
